import styles from "./ErrorMessage.module.scss";
import { ErrorMessage as FormikErrorMessage } from "formik";
import classNames from "classnames";

export const ErrorMessage = ({ name, children, spacing = "medium" }) => {
  const Container = ({ children }) => (
    <p
      className={classNames(styles.root, {
        [styles.medium]: spacing === "medium",
        [styles.large]: spacing === "large",
      })}
    >
      {children}
    </p>
  );

  return children ? (
    <Container>{children}</Container>
  ) : (
    <FormikErrorMessage
      name={name}
      render={(message) => <Container>{message}</Container>}
    />
  );
};
